import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AgendaContext } from '../../../contexts/AgendaContext.jsx';
// Mui components
import { Box, Typography } from '@mui/material';
// Components
import DetailSkeleton from '../../common/DetailSkeleton.jsx';
// Icons
import IconChevronLeft from '../../../utils/images/icon_chevron-left.svg';
// ErrorProvider
import { useError } from '../../../contexts/ErrorProvider.jsx';
import DetailUserConsultorio from './DetailUserConsultorio.jsx';
import SeccionInfoConsultorio from './SeccionInfoConsultorio.jsx';
import SeccionPreferenciasNotificacion from './SeccionPreferenciasNotificacion.jsx';

function DetailConsultorio() {

  const { consultorioId } = useParams();
  const navigate = useNavigate();
  const { prestadorSesion, getPrestadorSesion, consultorioDetail, dispatch, getSolicitudes } =
    useContext(AgendaContext);

  const { handleError } = useError();

  const [loader, setLoader] = useState(true);

  useEffect(() => {
    if (!prestadorSesion) {
      getInfoConsultorioComponentMount();
    } else {
      buscarConsultorioPorId();
    }
  }, [prestadorSesion]);

  const getInfoConsultorioComponentMount = async () => {
    try {
      await getPrestadorSesion();
      await getSolicitudes();
      buscarConsultorioPorId();
    } catch (error) {
      handleError({ error: error, description: 'initializeError' });
    }
  };

  const buscarConsultorioPorId = () => {
    const consultorio = prestadorSesion?.consultorios?.find(
      (consultorio) => consultorio?.consultorioOsde[0]?.consultorioId === consultorioId
    );

    if (consultorio) {
      dispatch({ type: 'GET_CONSULTORIO_DETAIL', payload: consultorio });
      setLoader(false);
    }
  };

  return consultorioDetail ? (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingBottom: '5rem',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
      <Box
        sx={{
          display: 'flex',
          width: '920px',
          marginTop: 'calc(3rem + 76px)',
          marginLeft: '4rem',
          height: '100%',
          flexDirection: 'column',
          gap: '2.5rem'
        }}>
        <Box
          onClick={() => navigate('/prestador/misConsultorios')}
          sx={{
            display: 'flex',
            gap: '1rem',
            alignItems: 'center',
            cursor: 'pointer'
          }}>
          <Box
            component="img"
            sx={{ width: '25px', height: '25px', cursor: 'pointer' }}
            alt="img not found"
            src={IconChevronLeft}
          />
          <Typography variant="h2">Detalle del consultorio</Typography>
        </Box>

        <DetailUserConsultorio />

        <SeccionInfoConsultorio consultorio={consultorioDetail} />

        <SeccionPreferenciasNotificacion consultorio={consultorioDetail} />

      </Box>
    </Box>
  ) : (
    loader && <DetailSkeleton />
  );
}

export default DetailConsultorio;
